
import { Progress } from "@/components/ui/progress";
import { Loader2, Sparkles } from "lucide-react";

interface CollectionCardProgressProps {
  isProcessing: boolean;
  progressPercentage: number;
  processedItems: number;
  totalItems: number;
  currentAction: string;
  onRegenerateStart?: () => void;
  processType?: 'product_upload' | 'translation' | 'import' | 'none';
}

export const CollectionCardProgress = ({
  isProcessing,
  progressPercentage,
  processedItems,
  totalItems,
  currentAction,
  onRegenerateStart,
  processType
}: CollectionCardProgressProps) => {
  if (!isProcessing) {
    return null;
  }

  return (
    <div className="mt-3 space-y-2 border-t pt-3">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <div className="flex items-center gap-1">
          <Sparkles className="h-3 w-3 animate-pulse text-purple-500" />
          <Loader2 className="h-3 w-3 animate-spin" />
        </div>
        <span className="font-medium">
          {processType === 'translation' 
            ? 'AI translating descriptions...' 
            : processType === 'import' 
            ? 'Importing products...' 
            : 'AI generating descriptions...'
          }
        </span>
      </div>
      
      <div className="space-y-1">
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>{currentAction || 'Processing...'}</span>
          {!currentAction?.includes('/') && (
            <span>{processedItems}/{totalItems}</span>
          )}
        </div>
        <Progress value={progressPercentage} className="h-1.5" />
        <div className="text-xs text-muted-foreground">
          {progressPercentage}% complete
        </div>
      </div>
    </div>
  );
};
